const PostMessageType = {
    push: 'navigation-push',
    replace: 'navigation-replace',
    back: 'navigation-back',
};

export default PostMessageType;
